import React from "react";
import { Container, Typography, Box, Paper } from "@mui/material";

const AboutUs: React.FC = () => {
  return (
    <Container maxWidth="md" sx={{ mt: 8, textAlign: "center" }}>
      <Paper elevation={3} sx={{ p: 4 }}>
        <Typography component="h1" variant="h4" gutterBottom>
          Sobre Nós
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          Nós somos uma equipe dedicada a criar soluções de segurança digital acessíveis e eficazes. Acreditamos que todos merecem a
          tranquilidade de saber que suas informações estão seguras.
        </Typography>
        <Typography variant="body1" color="text.secondary" paragraph>
          O Gerenciador de Senhas Fidelius foi desenvolvido com o objetivo de oferecer uma ferramenta robusta e fácil de usar para gerenciar
          suas credenciais online. Nosso compromisso é com a sua segurança, usando criptografia de ponta e garantindo que apenas você tenha
          acesso às suas senhas.
        </Typography>
      </Paper>
    </Container>
  );
};

export default AboutUs;
